import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Feature, CreateFeatureDto, UpdateFeatureDto } from '../models/feature.model';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {
  private http = inject(HttpClient);

  /**
   * Get a single feature by ID
   * @param pagerDutyServiceId The PagerDuty Service ID
   * @param applicationId The Application ID
   * @param featureId The Feature ID
   * @returns Observable of HttpResponse containing the Feature
   */
  getFeatureById(pagerDutyServiceId: string, applicationId: string, featureId: string): Observable<HttpResponse<Feature>> {
    const endpoint = `${environment.baseUrl}/${environment.serviceConfigUrl}/${pagerDutyServiceId}/applications/${applicationId}/features/${featureId}`;
    return this.http.get<Feature>(endpoint, { observe: 'response', responseType: 'json' });
  }

  /**
   * Create a new feature within an application
   * @param pagerDutyServiceId The PagerDuty Service ID
   * @param applicationId The Application ID
   * @param featureDto Feature data
   * @returns Observable of HttpResponse containing the created Feature
   */
  createFeature(pagerDutyServiceId: string, applicationId: string, featureDto: CreateFeatureDto): Observable<HttpResponse<Feature>> {
    const endpoint = `${environment.baseUrl}/${environment.serviceConfigUrl}/${pagerDutyServiceId}/applications/${applicationId}/features`;
    return this.http.post<Feature>(endpoint, featureDto, { observe: 'response', responseType: 'json' });
  }

  /**
   * Update an existing feature
   * @param pagerDutyServiceId The PagerDuty Service ID
   * @param applicationId The Application ID
   * @param featureId The Feature ID
   * @param featureDto Feature data
   * @returns Observable of HttpResponse containing the updated Feature
   */
  updateFeature(pagerDutyServiceId: string, applicationId: string, featureId: string, featureDto: UpdateFeatureDto): Observable<HttpResponse<Feature>> {
    const endpoint = `${environment.baseUrl}/${environment.serviceConfigUrl}/${pagerDutyServiceId}/applications/${applicationId}/features/${featureId}`;
    return this.http.patch<Feature>(endpoint, featureDto, { observe: 'response', responseType: 'json' });
  }

  /**
   * Delete a feature
   * @param pagerDutyServiceId The PagerDuty Service ID
   * @param applicationId The Application ID
   * @param featureId The Feature ID
   * @returns Observable of HttpResponse
   */
  deleteFeature(pagerDutyServiceId: string, applicationId: string, featureId: string): Observable<HttpResponse<void>> {
    const endpoint = `${environment.baseUrl}/${environment.serviceConfigUrl}/${pagerDutyServiceId}/applications/${applicationId}/features/${featureId}`;
    return this.http.delete<void>(endpoint, { observe: 'response' });
  }
}
